<div class="dialog-content modal-container" fxLayout="column">
  <mat-card appearance="outlined" class="edit-section edit-form extra-padding">
    <ng-container
      *ngTemplateOutlet="
        attachmentTemplate;
        context: {
          attachments: data.labAnalyticalAttachments,
          label: 'Lab Analytical Attachment'
        }
      "
    ></ng-container>
  </mat-card>
  <mat-card appearance="outlined" class="edit-section edit-form extra-padding">
    <ng-container
      *ngTemplateOutlet="
        attachmentTemplate;
        context: {
          attachments: data.safetyDataSheets,
          label: 'Safety Data Sheet'
        }
      "
    ></ng-container>
  </mat-card>
  <mat-card appearance="outlined" class="edit-section edit-form extra-padding">
    <ng-container
      *ngTemplateOutlet="
        attachmentTemplate;
        context: {
          attachments: data.additionalSupplements,
          label: 'Additional Supplements'
        }
      "
    ></ng-container>
  </mat-card>

  <button
    mat-icon-button
    cdkFocusInitial
    class="close"
    aria-label="Close dialog"
    color="accent"
    [disableRipple]="true"
    [mat-dialog-close]=""
  >
    <mat-icon>close</mat-icon>
  </button>
</div>

<ng-template
  #attachmentTemplate
  let-attachments="attachments"
  let-label="label"
>
  <div>
    <label>{{ label }}</label>
  </div>

  <div *ngIf="attachments?.length > 0">
    <div *ngFor="let attachment of attachments">
      <a
        target="_blank"
        *ngIf="attachment?.attachment?.fileUrl"
        [href]="attachment.attachment.fileUrl"
        >{{ attachment.attachment.fileUrl }}</a
      >
      <br />
      <h4 *ngIf="!attachment?.attachment?.fileUrl">
        No previous attachments available in our system
      </h4>
    </div>
  </div>
  <div *ngIf="attachments?.length === 0">
    <h4>No previous attachments available in our system</h4>
  </div>
</ng-template>
